import { ApiOrderDetailsResponse } from 'src/app/core/models';
import { orders } from './order.mock';

export const getOrderDetails = (urlParams: any): ApiOrderDetailsResponse | null => {
  const orderId = parseInt(urlParams?.orderId);

  if (!orderId) return null;

  const order = orders.find((o) => o.id === orderId);

  if (!order) return null;

  return {
    orderItemDetails: order.mockDetails.orderItemDetails,
    primaryInsurance: order.mockDetails.primaryInsurance,
    secondaryInsurance: order.mockDetails.secondaryInsurance,
  };
};
